import { getImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import "react-multi-carousel/lib/styles.css";
import ReactPlayer from "react-player";
import { GatsbyImage } from "gatsby-plugin-image";

const TestimonialsVideoWritten = ({
	body,
	companyName,
	position,
	name,
	logo,
	video,
	image,
	mediaType,
}) => {

	return (
		<section style={testimonialSectionStyles}>
			<Container>
				<Row className="align-items-center g-3 g-lg-7">
					{/* Video Player */}

					{/* Featured Testimonial */}
					<Col
						xs={12}
						lg={6}
						className="d-flex flex-column justify-content-center"
					>
						<p className="fs-5 text-primary outfit-bold text-center text-md-start pb-3">
							"{body}"
						</p>
						<div className="d-flex align-items-center">
							<div
								style={{ borderRight: "2px solid #00304B" }}
								className="d-block pe-3 py-2"
							>
								<p className="py-0 my-0 outfit-bold">{name}</p>
								<small
									style={{ color: "#00527B" }}
									className="text-primary calibri py-0 my-0"
								>
									{position}
									{position ? "," : ""} {companyName}
								</small>
							</div>
							<div className="ps-3">
								<img
									src={logo}
									alt={`${companyName} Logo`}
									style={logoStyles}
									className="mt-2"
								/>
							</div>
						</div>
					</Col>
					<Col
						xs={12}
						lg={{ span: 6, order: "first" }}
						className="text-center mb-4 mb-lg-0"
					>
						{mediaType === "Video" && (
							<div className="pb-0">
								<ReactPlayer
									className="video-border"
									url={video}
									controls
									width="100%"
									height="100%"
								/>
							</div>
						)}
						{mediaType === "Image" && (
							<div style={{ overflow: "hidden" }} className="video-border">
								<GatsbyImage
									image={image?.localFile?.childImageSharp?.gatsbyImageData}
									alt={image?.altText || "Image"}
									className="w-100 h-100"
									style={{ maxHeight: "340px"}}
								/>
							</div>
						)}
						
					</Col>
				</Row>
			</Container>
		</section>
	);
};

// Custom Left Arrow
const CustomLeftArrow = ({ onClick }) => (
	<button
		onClick={onClick}
		className="custom-arrow custom-left-arrow"
		style={{ ...arrowStyles, right: "60px" }}
	>
		<FaArrowLeft className="fs-5" />
	</button>
);

// Custom Right Arrow
const CustomRightArrow = ({ onClick }) => (
	<button
		onClick={onClick}
		className="custom-arrow custom-right-arrow"
		style={{ ...arrowStyles, right: "0px" }}
	>
		<FaArrowRight className="fs-5" />
	</button>
);

// Inline Styles
const testimonialSectionStyles = {
	padding: "50px 0",
};

const testimonialCardStyles = {
	border: "1px solid #CEE4FF",
	borderRadius: "12px",
};

const avatarStyles = {
	width: "50px",
	height: "50px",
	borderRadius: "50%",
};

const logoStyles = {
	width: "80px",
	height: "auto",
	marginTop: "1rem",
};

const arrowStyles = {
	position: "absolute",
	bottom: "0px",
	transform: "translateY(-50%)",
	zIndex: 2,
	backgroundColor: "white",
	border: "1px solid #00304B",
	borderRadius: "50%",
	width: "50px",
	height: "50px",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	cursor: "pointer",
	boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
};

// Global CSS for Custom Dots

export default TestimonialsVideoWritten;
